<template>
  <div id="app">
    <router-view :window_height="window_height"></router-view>
  </div>
</template>

<script>

  export default {
    name: 'App',
    data(){
      return{
        window_height:`${document.documentElement.clientHeight}px`
      }
    },
    created(){
      this.$Message.config({
        duration: 3
      });
    },
    mounted() {
      window.onresize = () => {
        this.window_height = `${document.documentElement.clientHeight}px`;
      }
    },
  }
</script>

<style>

  ::-webkit-scrollbar {
    width: 0;
    height: 12px;
    background-color: #c9c9c9;
  }

  ::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    border-radius: 2px;
    background-color: #c9c9c9;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 5px;
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, .3);
    background-color: #fc8c30;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue